"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LanguageOptionsDtoTierEnum = void 0;
exports.instanceOfLanguageOptionsDto = instanceOfLanguageOptionsDto;
exports.LanguageOptionsDtoFromJSON = LanguageOptionsDtoFromJSON;
exports.LanguageOptionsDtoFromJSONTyped = LanguageOptionsDtoFromJSONTyped;
exports.LanguageOptionsDtoToJSON = LanguageOptionsDtoToJSON;
exports.LanguageOptionsDtoToJSONTyped = LanguageOptionsDtoToJSONTyped;
var LanguageGroupDto_1 = require("./LanguageGroupDto");
/**
 * @export
 */
exports.LanguageOptionsDtoTierEnum = {
    Free: 'free',
    Pro: 'pro',
    Champion: 'champion'
};
/**
 * Check if a given object implements the LanguageOptionsDto interface.
 */
function instanceOfLanguageOptionsDto(value) {
    if (!('tier' in value) || value['tier'] === undefined)
        return false;
    if (!('selectedId' in value) || value['selectedId'] === undefined)
        return false;
    if (!('groups' in value) || value['groups'] === undefined)
        return false;
    return true;
}
function LanguageOptionsDtoFromJSON(json) {
    return LanguageOptionsDtoFromJSONTyped(json, false);
}
function LanguageOptionsDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'tier': json['tier'],
        'selectedId': json['selectedId'],
        'groups': (json['groups'].map(LanguageGroupDto_1.LanguageGroupDtoFromJSON)),
    };
}
function LanguageOptionsDtoToJSON(json) {
    return LanguageOptionsDtoToJSONTyped(json, false);
}
function LanguageOptionsDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'tier': value['tier'],
        'selectedId': value['selectedId'],
        'groups': (value['groups'].map(LanguageGroupDto_1.LanguageGroupDtoToJSON)),
    };
}
